<div>
  <label class="d-inline-block pl-0">
    <ng-content> </ng-content>
  </label>

  <div class="d-inline-block float-right" *ngIf="info">
    <img class="info-button--height" src="../../../assets/images/info-button.png" />
  </div>
</div>
